import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function getLanguageFromBrowser(): string {
  const supported = ["de", "en", "fr", "es"];
  const raw = (navigator.language || "").toLowerCase();

  for (const lang of supported) {
    if (raw.startsWith(lang)) return lang;
  }

  return "en";
}

export default function LanguageRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const lang = getLanguageFromBrowser();
    navigate(`/${lang}`, { replace: true });
  }, [navigate]);

  return null;
}